import React from 'react'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import { Map as MapPigeon, Marker as MarkerPigeon } from "pigeon-maps";
import { toAbsoluteUrl } from '../../_metronic/helpers';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'; // CSS dari react-leaflet

interface MapLocationMeetingProps {
    latitudeMap: number
    longitudeMap: number
    typeMeeting: string
}

const MapLocationMeeting = ({ latitudeMap, longitudeMap, typeMeeting }: MapLocationMeetingProps) => {
    const customMarker = new L.Icon({
        iconUrl: toAbsoluteUrl('/media/logos/marker.png'), // Tentukan URL gambar ikon
        iconSize: [38, 38], // Tentukan ukuran ikon [lebar, tinggi]
        iconAnchor: [19, 38], // Tentukan titik anchor ikon [posisi x, posisi y]
        popupAnchor: [0, -38] // Tentukan titik anchor popup [posisi x, posisi y]
    });

    const color = `hsl(${0 % 360}deg 39% 70%)`


    return (
        <>
            {
                (latitudeMap !== 0 && longitudeMap !== 0) &&
                (
                    typeMeeting === 'schedule' ?
                        <MapContainer key={`${latitudeMap}-${longitudeMap}`} center={[latitudeMap, longitudeMap]} zoom={22} scrollWheelZoom={true} style={{ height: '300px', width: '100%', zIndex: "0" }} attributionControl={false} preferCanvas={false}>
                            <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[latitudeMap, longitudeMap]} icon={customMarker} autoPanOnFocus>
                            </Marker>
                        </MapContainer>
                        :
                        <MapPigeon key={`${latitudeMap}-${longitudeMap}`} height={200} defaultCenter={[latitudeMap, longitudeMap]} defaultZoom={16} attribution={false} >
                            <MarkerPigeon
                                key={`${latitudeMap}-${longitudeMap}`}
                                width={50}
                                height={50}
                                anchor={[latitudeMap, longitudeMap]}
                                color={color}
                            />
                        </MapPigeon>
                )
            }
        </>
    )
}

export default MapLocationMeeting